import { create } from 'zustand'

interface ModalAllPropertyState {
  modalAllProperty: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalAllProperty: (modalAllProperty: {
    isOpen: boolean
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalAllProperty: {
    isOpen: false
  }
}

export const useModalAllPropertyStore = create<ModalAllPropertyState>()(
  (set) => ({
    ...initialState,
    setModalAllProperty: (modalAllProperty) => set({ modalAllProperty }),
    reset: () =>
      set({
        modalAllProperty: initialState.modalAllProperty
      })
  })
)
